<template lang="pug">
  .recent-invoice
    InvoiceStatusBar.row(:status="invoice.shipping_status")
    InvoiceWithActionsLayout
      template(#items="")
        InvoiceItem(v-for="item in invoiceItems" :item="item" :key="item.id").xs-12

      template(#totals="")
        span.xs-f-xsmall.lg-f-small.max-at-tweak.upper.color-slate Total&nbsp;
        span.md-hide.lg-hide :&nbsp;
        span.xs-f-medium.lg-f-xmedium.max-at-tweak.bold {{ invoice.total | currency }}

      template(#ctas="")
        a.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(v-if="invoice.tracking_url && trackFirst" :href="invoice.tracking_url") Track my box
        router-link.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:to="invoiceDetailsUrl" :class="{ 'btn-inverse': orderDetailsNotPrimary }") Order Details
        a.mr-btn.btn-inverse.btn-block.xs-f-xsmall.max-at-tweak(v-if="invoice.tracking_url && !trackFirst" :href="invoice.tracking_url") Track my box
        router-link.mr-btn.btn-block.btn-inverse.xs-f-xsmall.max-at-tweak(v-if="invoiceSubId" :to="subUrl") Manage Subscription

</template>

<script>
  import InvoiceStatusBar from "../InvoiceStatusBar";
  import InvoiceItem from "../InvoiceItem/InvoiceItem";
  import InvoiceWithActionsLayout from "../InvoiceWithActionsLayout";

  export default {
    name: "RecentInvoice",
    components: {
      InvoiceWithActionsLayout,
      InvoiceItem,
      InvoiceStatusBar
    },

    props: {
      invoice: {
        type: Object,
        required: true
      }
    },

    computed: {
      invoiceDetailsUrl() {
        return `/dashboard/purchases/order-details/${this.invoice.id}`;
      },

      subUrl() {
        return `/dashboard/purchases/edit-auto-delivery/${this.invoiceSubId}`;
      },

      trackFirst() {
        return this.invoice.shipping_status != "delivered";
      },

      orderDetailsNotPrimary() {
        return this.trackFirst && this.invoice.tracking_url;
      },

      invoiceSubId() {
        return this.invoice.items[0].subscription_id;
      },

      invoiceItems() {
        return this.invoice.items.filter(item => item.type != 'shipping');
      }
    }
  }
</script>

<style scoped lang="stylus">
  .invoice-progress
    padding-bottom 1.5em

  .invoice-with-actions
    padding 0 1.5em 2em

</style>